// Cấu hình HIỂN THỊ tag KH (nhóm + nhãn + màu). GIÁ TRỊ phải khớp backend/src/config/customerTags.js.
// 3 nhóm, đa chọn mỗi nhóm: Dịch vụ (vc/mh) · Tuyến (jp/us) · Loại hàng (thuong/dientu).
// MÀU CỐ ĐỊNH (hex), KHÔNG dùng var(--accent)/--ok/... nữa: các biến đó đổi theo theme (teal/green/...) khiến
// tag VC/MH lẫn vào nền giao diện + badge SocSon/PMBox. Bảng màu tách hẳn: xanh dương / hồng / đỏ / tím / xám / cam.
export const TAG_GROUPS = [
  { key: 'svc', label: 'Dịch vụ', options: [
    { v: 'vc', label: 'Vận chuyển', short: 'VC', color: '#2563eb' },
    { v: 'mh', label: 'Mua hộ', short: 'MH', color: '#db2777' },
  ] },
  { key: 'route', label: 'Tuyến', options: [
    { v: 'jp', label: 'JP', short: 'JP', color: '#dc2626' },
    { v: 'us', label: 'US', short: 'US', color: '#7c3aed' },
  ] },
  { key: 'goods', label: 'Loại hàng', options: [
    { v: 'thuong', label: 'Hàng thường', short: 'Thường', color: '#64748b' },
    { v: 'dientu', label: 'Hàng điện tử', short: 'Điện tử', color: '#c2410c' },
  ] },
];

// Tra cứu 1 giá trị tag -> { label, short, color, group, groupLabel }. Tag lạ -> undefined (bỏ qua khi render).
export const TAG_INFO = {};
TAG_GROUPS.forEach((g) => g.options.forEach((o) => { TAG_INFO[o.v] = { ...o, group: g.key, groupLabel: g.label }; }));
export const ALL_TAG_VALUES = Object.keys(TAG_INFO);

// Tag hiện TRƯỚC TÊN KH trong CHAT (chỉ 3 loại, nhãn ngắn). Các tag khác (JP/US/hàng thường) KHÔNG hiện ở chat.
export const CHAT_TAG_ORDER = ['mh', 'vc', 'dientu'];
const CHAT_TAG_LABEL = { mh: 'MH', vc: 'VC', dientu: 'ĐT' };
// Trả [{v,label,color}] cho các tag chat có trong tags[], theo thứ tự CHAT_TAG_ORDER. Rỗng -> [].
export function chatTagsOf(tags) {
  const set = new Set(tags || []);
  return CHAT_TAG_ORDER.filter((v) => set.has(v)).map((v) => ({ v, label: CHAT_TAG_LABEL[v], color: TAG_INFO[v].color }));
}
